import { AVATAR_SIZE } from '@hapana/shared/web/components/shared/avatar/avatar.constants'
import '@hapana/shared/utils/type-defs.util'

/** @type{Styles} */
export const styles = {
  dialogContent: ({ breakpoints }) => ({
    overflow: 'hidden',
    borderWidth: 1,
    borderStyle: 'solid',
    borderColor: 'gray.8',
    borderRadius: 2,
    boxShadow: '0px 1px 2px rgba(0, 0, 0, 0.04)',
    [breakpoints.down('sm')]: {
      border: 0,
      borderRadius: 0,
    },
  }),

  contentContainer: ({ breakpoints }) => ({
    display: 'grid',
    paddingX: 0,
    paddingBottom: 0,
    columnGap: {
      xs: 1.5,
      sm: 2,
    },
    gridTemplateColumns: 'auto 1fr',
    alignItems: {
      xs: 'center',
      sm: 'start',
    },
  }),
  openedColumnGap: {
    columnGap: {
      xs: 1.5,
      sm: 4,
    },
  },
  mostRecentCheckInContainer: {
    paddingTop: {
      xs: 2.5,
      sm: 3,
    },
  },

  gridTemplate: {
    gridTemplateRows: 'min-content 1fr',
    rowGap: 2,
  },
  contentContainerAnimatedSpacing: {
    marginTop: 3,
  },
  contentContainerAnimated: {
    alignItems: { xs: 'start' },
  },
  avatarHolderAnimated: {
    gridRow: {
      xs: 1,
      sm: 'span 2',
    },
    paddingLeft: {
      xs: 0,
      sm: 2,
    },
  },
  avatarHolder: {
    gridRow: {
      xs: 1,
      sm: 'span 2',
    },
    marginBottom: {
      sm: 2,
      md: 3,
    },
    marginLeft: {
      sm: 3,
    },
    marginRight: {
      sm: 2,
    },
  },
  avatarOverlay: {
    position: 'relative',
    cursor: 'pointer',

    '.MuiAvatar-root:after': {
      backgroundColor: 'transparent',
      position: 'absolute',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      content: '""',
      transition: (theme) => theme.transitions.create(),
    },
    '.MuiSvgIcon-root': {
      opacity: 0,
    },
    '&:hover': {
      '.MuiAvatar-root:after': {
        backgroundColor: 'gray.100',
        opacity: 0.48,
      },
      '.MuiSvgIcon-root': { opacity: 1 },
    },
  },
  avatarIcon: {
    transition: (theme) => theme.transitions.create(),
    color: 'gray.0',
    opacity: 0,
    zIndex: 'mobileStepper',
    fontSize: 16,
    position: 'absolute',
    margin: 'auto',
    inset: 0,
  },

  openedSpacing: {
    marginBottom: {
      xs: 2.5,
      sm: 3,
    },
    paddingBottom: 0,
    paddingTop: {
      xs: 0,
    },
  },

  infoContainer: ({ breakpoints }) => ({
    gridColumn: {
      xs: 'span 2',
      sm: '2',
    },
    [breakpoints.down('sm')]: {
      marginLeft: 0,
      marginTop: 0,
    },
  }),
  addNoteSpacing: {
    marginBottom: {
      xs: 0,
      sm: 2,
    },
  },

  packagesIcon: {
    fontSize: 20,
    color: 'gray.56',
  },
  noPackagesIcon: {
    fontSize: 20,
    color: 'gray.40',
  },
  membershipField: {
    color: 'gray.56',
    fontSize: 14,
  },
  circle: {
    color: 'gray.40',
    fontSize: 14,
  },

  locationSession: {
    display: 'flex',
    gap: 1,
    alignItems: 'center',
  },
  cartAndAddNoteButtons: {
    marginBottom: {
      xs: 2,
      sm: 0,
    },
  },
  addNoteButton: {
    marginLeft: 0,
  },
  cartButton: {
    marginLeft: 1,
  },

  profileOptions: {
    paddingRight: 2,
  },
  itemWrapper: {
    paddingY: {
      xs: 2.25,
      sm: 2.5,
    },
    paddingTop: {
      xs: 0,
      sm: 0,
    },
    '&:not(:last-of-type)': {
      borderBottom: 1,
      color: 'gray.8',
    },
  },
  itemWrapperOpened: {
    paddingBottom: {
      sm: 0,
    },
  },
  nameAndViewProfileContainer: {
    alignSelf: 'center',
  },
  flexSpaceBetween: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
  columnGap: {
    columnGap: {
      sm: 2,
    },
    paddingTop: {
      xs: 2.5,
    },
  },
  firstItemClosed: {
    paddingTop: {
      xs: 0,
      sm: 2.5,
    },
  },
  pointer: {
    cursor: 'pointer',
  },
  flexColumn: {
    display: 'flex',
    flexDirection: 'column',
  },

  flex: { display: 'flex' },
  arrowIcon: { color: 'gray.56', alignSelf: 'center', fontSize: 20 },
  arrowIconRightSpace: { marginRight: 2 },
  fadeStyles: {
    opacity: 0,
    height: 'inherit',
    display: 'none',
  },
  revertedFadeStyles: {
    opacity: 1,
    height: 0,
    display: 'block',
  },
  rotateStyles: {
    transformOrigin: 'center',
  },

  userName: {
    marginRight: 1,
  },
  bannerAndNameContainer: {
    flexGrow: 1,
  },
  badgesWrapper: ({ breakpoints }) => ({
    borderLeftWidth: 1,
    borderLeftColor: 'gray.8',
    borderLeftStyle: 'solid',
    marginLeft: 2,
    paddingLeft: 2,
    [breakpoints.down('sm')]: {
      marginBottom: 2,
    },
    alignItems: 'center',
    display: 'flex',
  }),
  actionToAlertsWrapper: {
    display: 'flex',
    alignItems: 'center',
  },
  actionToAlerts: {
    cursor: 'pointer',
    marginLeft: 2,
    marginRight: -1,
    padding: 1,
  },
  rightArrowIcon: {
    fontSize: 16,
    cursor: 'pointer',
  },
  backLabelHeader: {
    display: 'flex',
    alignItems: 'center',
  },
  dot: {
    marginLeft: 0.5,
    marginRight: 0.5,
  },
  rectangularSkeleton: { marginLeft: 0.5 },
  mediumSpacingRectangularSkeleton: { marginLeft: 1 },
  skeletonGroup: {
    display: ' flex',
    flexDirection: 'row',
    alignItems: 'center',
    position: 'relative',
  },
  smallCircularSkeleton: { height: 16, width: 16 },
  mediumCircularSkeleton: { height: 20, width: 20 },
  flexRowCentered: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  },
  badgeSkeletonSpacing: { marginLeft: 2 },
  skeletonGroupItem: {
    height: 20,
    width: 20,
    position: 'absolute',
    marginLeft: 1,
    borderColor: 'gray.0',
    borderWidth: 2,
    borderStyle: 'solid',
    boxSizing: 'content-box',
  },
  skeletonSecondGroupItem: {
    height: 20,
    width: 20,
    position: 'absolute',
    marginLeft: 2.25,
    borderColor: 'gray.0',
    borderWidth: 2,
    borderStyle: 'solid',
    boxSizing: 'content-box',
  },
  alertsSkeletonContainer: {
    paddingY: 2.25,
    paddingX: 2,
    display: ' flex',
    flexDirection: 'row',
    alignItems: 'center',
    borderWidth: 1,
    borderStyle: 'solid',
    borderColor: 'gray.8',
  },
  alertsWrapper: ({ breakpoints }) => ({
    borderTop: 1,
    borderColor: 'gray.8',
    '& .MuiDivider-root': {
      borderColor: 'gray.8',
    },
    [breakpoints.down('sm')]: {
      border: 1,
      borderColor: 'gray.8',
      borderRadius: 1,
    },
    marginTop: {
      xs: 1.75,
      sm: 2.5,
    },
  }),
}

export const handleStylesWithProps = ({ isOpen }) => ({
  avatarAnimation: {
    height: isOpen ? AVATAR_SIZE.PROFILE : AVATAR_SIZE.LARGE,
    width: isOpen ? AVATAR_SIZE.PROFILE : AVATAR_SIZE.LARGE,
  },
  avatarAnimationMobile: {
    height: isOpen ? AVATAR_SIZE.EXTRA_LARGE : AVATAR_SIZE.LARGE,
    width: isOpen ? AVATAR_SIZE.EXTRA_LARGE : AVATAR_SIZE.LARGE,
  },
  fadeAnimation: {
    opacity: isOpen ? 1 : 0,
    height: isOpen ? 'inherit' : 0,
    display: isOpen ? 'block' : 'none',
  },
  revertedFadeAnimation: {
    opacity: isOpen ? 0 : 1,
    height: isOpen ? 0 : 'inherit',
    display: isOpen ? 'none' : 'block',
  },
  rotateAnimation: {
    transform: isOpen ? 'rotate(180deg)' : 'rotate(0deg)',
  },
})
